module.exports = __webpack_public_path__ + "static/about-us-21-20bbbf0269b70b0a72c1caffdfa1f449.jpg";